import { object, boolean } from 'yup'

export default object({
  suppress_pickups_for_insufficient_refund_enabled: boolean()
})
